<template>
  <div class="p-hb">
    <div class="p-hb-bg" :style='{ backgroundImage: `url(${bannerImage})` }'>
    </div>
    <div class="p-hb-main">
      <div class="p-hb-box">
        <!-- <img :src="baseData.logo" alt=""> -->
        <p class="title">{{baseData.title}}</p>
        <p class="subtitle">{{baseData.subtitle}}</p>
        <div class="btn">
          <kd-button class="primary-btn" @click="downloadClick(downloadUrl, baseData.buttonEvent)">{{baseData.buttonTxt}}</kd-button>
          <!-- <kd-button class="primary-btn" @click="downloadClick(baseData.url2, baseData.buttonEvent2)">{{baseData.buttonTxt2}}</kd-button> -->
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import {bannerData} from '../config'
import bannerWebp from '@/assets/images/home/banner.webp'
import bannerPng from '@/assets/images/home/banner.png'
import { getFromPage, getPageName } from '@/common/utils/index'
import infoCollect from '@/common/infoCollect';
export default {
  name: 'work-component',
  data () {
    return {
      downloadUrl: bannerData.url,
      baseData: bannerData,
      bannerImage: localStorage.isSupportWebp === 'true' ? bannerWebp : bannerPng
    }
  },
  async mounted() {
    let result = await this.$http({
      method: 'get',
      url: `https://plus.wps.cn/ops/opsd/api/v1/policy?window_key=wps365_download_edu_pc_muti&utm_source=wps&utm_medium=edu_app&from=koa`,
    })
    result?.data?.forEach(element => {
      if (element.key === 'downloadcontent') {
        const obj = JSON.parse(element.value)
        obj?.forEach(item => {
          if (item.type === 'pc') {
            this.downloadUrl = item.link
          }
        })
      }
    });
  },
  methods: {
    downloadClick(url, name) {
      infoCollect.dwCollectData('button_click', name, 'PC', {'page_name': getPageName(), 'from_item': getFromPage()})
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-hb{
  height: 536px;
  position: relative;
  padding-top: 124px;
  &-bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    overflow: hidden;
    background-color: #6f706d;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  &-main{
    position: relative;
    z-index: 2;
    width: 1200px;
    height: 282px;
    margin: 0 auto;
    @include responsive(2560) {
    
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  @media screen and (max-width: $width-l) {
    padding-left: 32px;
    &-main{
      width: 100%;
    }
  }
  &-box{
    height: 100%;
    position: relative;
    img{
      width: 218px;
      height: 48px;
    }
    .title{
      font-size: 48px;
      line-height: 64px;
      color: #FFFFFF;
      margin-top: 24px;
    }
    .subtitle{
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.9);
      margin-top: 20px;
    }
    .btn{
      margin-top: 48px;
      button{
        width: 184px;
        height: 58px;
        font-size: 18px;
        font-weight: 500;
        padding: 0;
      }
      button + button{
        margin-left: 16px;
      }
    }
  }
}
</style>
